import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericResponse } from '@otas/model/genericResponse';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AutobackupService {

  constructor(private http: HttpClient) { }
  autoBackUpSave(data): Observable<GenericResponse<any>> {
    return this.http.put<GenericResponse<any>>(`temple/autobackup/setting`, data);
  }

  onlineSynchronization(): Promise<any> {
    return this.http.get<any>(`temple/online/synchronization`)
      .toPromise();
  }
}
